import React, { useEffect } from "react";
import { AirlineForm } from "./Forms/AirlineForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneAirlineQuery,
  useUpdateAirlineMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditAirline = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: airlineResponse,
    isLoading,
    isFetching,
  } = useGetOneAirlineQuery({ id });
  const airline = airlineResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateAirline, isPending } = useUpdateAirlineMutation(setError);

  const onSubmit = (data) => {
    updateAirline(data);
  };

  useEffect(() => {
    if (airline) {
      reset(airline);
    }
  }, [airline, reset]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_AIRLINE")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <AirlineForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_AIRLINE")}
                  </>
                ) : (
                  t("UPDATE_AIRLINE")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};

